import React from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import '../../styles/RTIPage.css';

const RTIPage = () => {
  return (
    <>
      <Navbar />

      <section className="rti-section fade-in">
        <div className="rti-container">
          <h2 className="rti-title">Right to Information (RTI)</h2>
          <p className="rti-description">
            The Right to Information Act, 2005 empowers Indian citizens to seek information from public authorities,
            promoting transparency and accountability in governance.
          </p>

          <div className="rti-subsection">
            <h3>RTI Cell</h3>
            <p>
              Our college has established an RTI Cell to facilitate easy access to information and ensure prompt responses to
              queries filed under the RTI Act.
            </p>
          </div>

          <div className="rti-subsection">
            <h3>RTI Officer</h3>
            <p><strong>Name:</strong> Dr. Anil Patil<br />
               <strong>Designation:</strong> Public Information Officer<br />
               <strong>Email:</strong> rti@shrimulikadevicollege.com<br />
               <strong>Phone:</strong> +91-9876543210
            </p>
          </div>

          <div className="rti-subsection">
            <h3>Documents</h3>
            <ul>
              <li><a href="/pdfs/rti-act-2005.pdf" target="_blank" rel="noopener noreferrer">RTI Act 2005 (Download)</a></li>
              <li><a href="/pdfs/rti-policy.pdf" target="_blank" rel="noopener noreferrer">College RTI Policy (Download)</a></li>
            </ul>
          </div>

          <div className="rti-subsection">
            <h3>Contact for RTI</h3>
            <p>
              For any queries or RTI applications, kindly contact the RTI Cell or email us directly.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default RTIPage;
